import {
  useTrackPageView,
  useTrackPageViewProps,
} from '../../utils/monorail.client';

export function RecordPageView(props: useTrackPageViewProps) {
  useTrackPageView(props);
  return null;
}
